exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-search[data-v-04eb1240]{border:none;border-radius:4px!important;padding:11px 46px;background:#2f23d6;transition:.2s}.button-search[data-v-04eb1240]:active,.button-search[data-v-04eb1240]:hover{background:#352da5}.button-search>.button-validate>.button-label[data-v-04eb1240]{font-weight:400;font-size:14px;line-height:130%;color:#fff}.button-search>.button-validate>.button-loading>.button-spinner>div[data-v-04eb1240]{margin-right:1.8px!important;height:20px!important}.button-search>.button-validate>.button-loading>.button-spinner .rect5[data-v-04eb1240]{margin-right:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04eb1240","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/buttons/btnSearch.vue
// module id = 558
// module chunks = 0